export default {
    namespaced: true,
    state: {
        unreadNotifications: 0,
    },
    mutations: {
        setUnreadNotifications(state, unreadNotifications) {
            state.unreadNotifications = unreadNotifications
        },
        resetNotifications(state) {
            state.unreadNotifications = 0;
        }
    },
    actions: {
    },
    getters: {
        getUnreadNotifications: (state) => state.unreadNotifications,
    },
}